import { ContentSection } from "@tiicker/util/lib/contentful/types";
import Accordion, { ClassNameOptions } from "components/Accordion/Accordion";
import { Entry } from "contentful";
import styles from "./PartnerWithUsFaqSection.module.scss";
import React from "react";
import Markdown from "components/Markdown/Markdown";

interface Props {
  title: string|undefined;
  subTitle: string|undefined;
  contentSections: Entry<ContentSection>[];
  includes: any;
}

const PartnerWithUsFaqSection = (props: Props) => {
  const transformKeys = (subobject) => {
    const { displayTitle, textContent, ...restFields } = subobject.fields;
    return {
      ...subobject,
      fields: {
        ...restFields,
        question: displayTitle,
        answer: textContent,
      },
    };
  };

  const copyObjectWithChangedSubobjectKeys = (objArray) => {
    // Convert the object to key-value pairs and change the subobject keys
    return objArray.map((obj) => {
      const newSubobject = transformKeys(obj);
      return newSubobject;
    });
  };

  const newArray = copyObjectWithChangedSubobjectKeys(props.contentSections);

  const classOptions: ClassNameOptions = {
    container: styles.PartnerWithUsFaqSection,
    panel: styles.PartnerWithUsFaqSection__panel,
    openPanel: styles.PartnerWithUsFaqSection__panel__open,
    outerTitle: styles.PartnerWithUsFaqSection__title,
    innerTitle: styles.PartnerWithUsFaqSection__innerTitle,
    loadingTitle: styles.PartnerWithUsFaqSection__loadingTitle,
    toggle: styles.PartnerWithUsFaqSection__toggle,
    toggleOpen: styles.PartnerWithUsFaqSection__toggle__open,
    content: styles.PartnerWithUsFaqSection__content,
  };
  console.log(newArray);

  return (
    <>
      <div className={styles.PartnerWithUsFaqSection__container}>
        <h4 className={styles.PartnerWithUsFaqSection__outerTitle}>{props.title}</h4>
        <p className={styles.PartnerWithUsFaqSection__outerSubtitle}>{props.subTitle}</p>
      </div>
      <Accordion
        singleOpen
        classNameOptions={classOptions}
      >
        {newArray.map((faq) => (
          <Accordion.Panel
            data-href="abc"
            key={`faq-${faq.sys.id}`}
            title={faq.fields.question}
          >
            <Markdown
              markdownText={faq.fields.answer}
              className={styles.PartnerWithUsFaqSection__content}
            />
          </Accordion.Panel>
        ))}
      </Accordion>
    </>
  )
};

export default PartnerWithUsFaqSection;
